import React from 'react'
import { motion } from 'framer-motion'
import { Typography } from '@mui/material'
import { Colors } from '../../constants/Colors'

export const createMotionVariants = (type: 'title' | 'description') => {
   const commonProps = {
      hidden: { opacity: 0, y: 50 },
      visible: {
         opacity: 1,
         y: 0,
         transition: {
            type: 'spring',
            stiffness: 120,
            damping: 15,
         },
      },
   }

   if (type === 'title')
      return {
         ...commonProps,
         visible: {
            ...commonProps.visible,
            transition: { type: 'spring', stiffness: 100, damping: 10 },
         },
      }

   return commonProps
}

export const AnimatedText: React.FC<{
   text: string
   type: 'title' | 'description'
   delay?: number
}> = ({ text, type, delay = 0 }) => (
   <motion.div
      initial="hidden"
      animate="visible"
      variants={createMotionVariants(type)}
      custom={delay}
   >
      <Typography
         variant={type === 'title' ? 'h4' : 'body1'}
         gutterBottom
         sx={{
            color: type === 'title' ? Colors.NAVY_BLUE : Colors.DARK_GRAY,
            mb: 1,
         }}
      >
         {text}
      </Typography>
   </motion.div>
)
